<template>
    <div>
        <a-modal
			:closable="false"
			wrap-class-name="full-modal"
			width="100%"
            :visible="isVisible"
			:dialog-style="{ top: '10px' }"
        >
			<template #footer>

				<a-button @click="handleBtnCancel" v-show="!isOnProductAdditional">
					Cancel
				</a-button>

				<a-button type="primary" @click="handleBtnSave" v-show="!isOnProductAdditional">
					Save
				</a-button>

				<a-button v-show="isOnProductAdditional" @click="handleBtnBackToProductBasic">
					Back
				</a-button>

				<a-button type="primary" v-show="isOnProductAdditional" @click="handleBtnSaveProductAdditonal">
					Save Option
				</a-button>

			</template>

			<div v-show="!isOnProductAdditional">

            	<a-form-model ref="productForm"  
						  		:model="item"
						  		:rules="productRules"
				>
				
                	<a-row type="flex" :gutter="24">
					
						<!-- Product Image col -->
						<a-col :span="24" :lg="6" class="mb-24">
					
							<!-- Product Image card -->
							<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0 }">
								<template #title>
									<h5 class="mb-0">Product Image</h5>
								</template>
								<image-uploader :imageUrl="item.imageUrl"
												:key="item.itemId" 
												@ready-upload="handleReadyUpload"
												@remove="handleRemoveFile"
												ref="imageUploader"
								/>
							</a-card>
							<!-- / Product Image card -->
						</a-col>
						<!-- / Product Image col -->

						<!-- Product Basic col -->
                    	<a-col :span="24" :lg="18" class="mb-24">

                        	<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }">

                            	<template #title>
                                	<h5 class="mb-0">Product Basic</h5>
                            	</template>

                            	<a-row :gutter="[24]">
									<!-- Product Name col -->
                                	<a-col :span="16">

							        	<a-form-model-item class="mb-10" 
															label="Product Name" 
															:colon="false"
												       		ref="itemName"
													   		prop="itemName"	   
										>
								        	<a-input allow-clear placeholder="eg. Minimal Bar Stool" 
												 	v-model="item.itemName"
												 	@blur="() => { $refs.itemName.onFieldBlur() }"
											/>
							        	</a-form-model-item>
						        	</a-col>
									<!--/ Product Name col -->

									<!-- Category col -->
                               		<a-col :span="8">
							        	<a-form-model-item class="mb-10" 
															label="Category" 
															:colon="false"
													   		ref="category"
													   		prop="category"
										>
											<a-select v-model="item.category" 
														placeholder="Please choose a category"

											>
												<template v-for="c in categories">
													<a-select-option :value="c.categoryId" :key="c.categoryId">
														{{ c.name }}
													</a-select-option>
												</template>
											</a-select>
							        	</a-form-model-item>
						        	</a-col>
									<!-- / Category col -->
								</a-row>

								<a-row :gutter="[24]">
									<!-- Price col -->
									<a-col :span="6">
								    	<a-form-model-item class="mb-10" 
															label="Price" :colon="false"
													   		ref="price"
													   		prop="price"
										>
									    	<a-input-number v-model="item.price"
															@blur="() => { $refs.price.onFieldBlur() }"
											/>
								    	</a-form-model-item>
							    	</a-col>
									<!-- / Price col -->

									<!-- Tax col -->
									<a-col :span="6">
								    	<a-form-model-item class="mb-10" 
															label="Tax (%)" 
															:colon="false"
													   		ref="tax"
													   		prop="tax"
										>
									   	 	<a-select v-model="item.tax">
												<template v-for="t in taxes">
													<a-select-option :key="t.taxId">
														{{ t.value }}
													</a-select-option>
												</template>
											</a-select>
								    	</a-form-model-item>
							    	</a-col>
									<!-- / Tax col -->

									<!-- Estimated time col -->
									<a-col :span="6">
								    	<a-form-model-item class="mb-10" 
															label="Estimated Time" 
															:colon="false"
													   		ref="estimatedTime"
													   		prop="estimatedTime"
										>
									    	<a-input-number v-model="item.estimatedTime"
															@blur="() => { $refs.estimatedTime.onFieldBlur() }"
											/>
								    	</a-form-model-item>
							    	</a-col>
									<!-- / Estimated time col -->

									<!-- Short Name col -->
                                	<a-col :span="6">

										<a-form-model-item class="mb-10" 
															label="Short Name" 
															:colon="false"
															ref="shortName"
															prop="shortName"	   
										>
											<a-input allow-clear placeholder="eg. Size S" 
													v-model="item.shortName"
											/>
										</a-form-model-item>
									</a-col>
									<!--/ Short Name col -->
								</a-row>

								<!-- Description col -->
								<a-row :gutter="[24]">
                                	<a-col :span="24">
								    	<a-form-model-item class="mb-10" label="Description" :colon="false">
											<a-textarea v-model="item.description" :rows="2">
											</a-textarea>
								    	</a-form-model-item>
							    	</a-col>

                                	<a-col :span="24">
							        	<a-form-model-item class="tags-field mb-10" label="Allergies" :colon="false">
								        	<a-select mode="multiple" v-model="item.allergies" style="width: 100%" placeholder="Tags Mode"
											>
									        	<a-select-option v-for="tag in allergies" :key="tag.Name" :value="tag.Name" selected >
											    	{{ tag.Name }}
									        	</a-select-option>
								        	</a-select>
							        	</a-form-model-item>
						        	</a-col>
                            	</a-row>
								<!-- / Description col -->

								
								<a-row :gutter="[24]">

									<!-- Group Options col -->
									<a-col :span="24" :lg="24" class="mb-24">
										<a-button @click="handleAddNewOption">
                                    		Add New Option
                    					</a-button>
										<a-card class="header-solid h-full" 
												:bodyStyle="{paddingTop: 0, paddingBottom: '20px'}"
										>
											<a-form-model-item class="tags-field mb-10" 
																:colon="false"
											>
												<template v-for="(i, index) in item.groupOptions">
													<group-option-view-popover :key="index"
																				:index="i.index"
																				:description="i.description"
																				:options="i.options"
																				@groupOptionEditEvent="handleGroupOptionEditEvent(index, i)"
													/>
												</template>
											</a-form-model-item>
										</a-card>
									</a-col>
									<!-- Group Options col -->

								</a-row>		
                        	</a-card>
                    	</a-col>
						<!-- / Product Basic col -->
                	</a-row>
            	</a-form-model>
			</div>
			<!-- Product Additional Div -->
			<div v-show="isOnProductAdditional">
				<a-row type="flex" :gutter="24">
					<a-col :span="24" :lg="24" class="mb-24">
						<group-options-div-view ref="groupOptionsDivView"
						@deleteGroupOptionEvent="handleDeleteProductAddditional"
						/>
					</a-col>
				</a-row>
			</div>
			<!-- / Product Additional Div -->
        </a-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import GroupOptionsDivView from './GroupOptionsAddDivView.vue'
import GroupOptionViewPopover from '../../../components/popovers/GroupOptionViewPopover.vue'
import ImageUploader from '../../../components/image/ImageUploader.vue'
import Allergies from '../../../common/entities/allergies.js'

export default {
	inject: ['eventBus'],
	props : {},

	components : {
		ImageUploader,
		GroupOptionsDivView,
		GroupOptionViewPopover
	},

	computed : {
		...mapState({
			categories : state => state.categories.categories,
			taxes : state => state.products.taxes,
			currency : state => state.localization.currency
		})
	},

    data () {
        return {
			productRules : {
				itemName : [
					{
						required : true,
						message : 'The field cannot be empty',
						trigger: 'blur'
					},
					{
						min: 3,
						message : 'The field should have at least 3 characters',
						trigger: 'blur'
					}
				],
				category : [
					{
						required : true,
						message : 'Please choose category'
					}
				],
				price : [
					{
						required : true,
						message : 'Please type a number',
						trigger: 'blur'
					}
				],
				tax : [
					{
						required : true,
						message : 'Please choose tax'
					}
				],
				estimatedTime : [
					{
						required : true,
						message: 'Please type a number',
						trigger: 'blur'
					}
				]

			},
			allergies : [],
            isVisible : false,
			isOnProductAdditional : false,
			maxGroupOptions : 5,
			viewport : {
				width : 750,
				height : 400
			},
			item : {
				itemId : '',
				itemName : '',
            	description : '',
            	price : 0.0,
            	tax : null,
            	category : null,
				estimatedTime : 0.0,
            	allergies : [],
            	addons : [],
            	groupOptions : [],
				imageUrl : '',
				shortName : ''
				
			},
            imageForUpload: [],
        }
    },

    methods : {
		//
		//Group Options Methods
		//
		handleBtnBackToProductBasic() {
			if (!this.isOnEditingOfProductAdditonal) {
				this.isOnProductAdditional= false;
			}
			else {
				this.isOnProductAdditional= false;
				this.isOnEditingOfProductAdditonal = false;
			}
			//this.$refs['groupOptionsDivView'].reset();
		},

		handleGroupOptionEditEvent(index, groupOptions) {
			console.log('Edit group options...')
			this.isOnEditingOfProductAdditonal = true;
			this.isOnProductAdditional = true;
			this.currentGroupOptionsIndex = index;
			this.$refs['groupOptionsDivView'].setGroupOptions(groupOptions);
		},

		handleBtnSaveProductAdditonal() {

			if (!this.isOnEditingOfProductAdditonal) {
				let payload = this.$refs['groupOptionsDivView'].getGroupOptions();

				if (payload != null) {
					this.item.groupOptions.push(payload);
				}
				this.isOnProductAdditional= false;
			}
			else {
				console.log('handleBtnSaveProductAdditonal')
				let payload = this.$refs['groupOptionsDivView'].getGroupOptions();
				console.log(payload)
				if (payload != null) {
					console.log(this.currentGroupOptionsIndex)
					if (this.currentGroupOptionsIndex > -1) {
						console.log('passed if')
						this.item.groupOptions[this.currentGroupOptionsIndex] = payload;
					}
				}
				this.isOnProductAdditional = false;
				this.isOnEditingOfProductAdditonal = false;
				this.currentGroupOptionsIndex = -1;
			}			
		},
		
		handleDeleteProductAddditional() {
			if(this.currentGroupOptionsIndex > -1) {
				this.item.groupOptions.splice(this.currentGroupOptionsIndex,1);
			}
			this.isOnProductAdditional = false;
			this.isOnEditingOfProductAdditonal = false;
			this.currentGroupOptionsIndex = -1;
		},
	
        handleBtnOk() {
            this.isVisible = false;
        },

        handleBtnCancel() {
            this.isVisible = false;
        },

		
		handleAddNewOption() {
			this.isOnProductAdditional = true;
		},

		handleBtnSave() {
			this.$refs.productForm.validate( async valid => {
				if (valid) {
					//
					//create allergies
					//
					let lstAllergies = [];
					for(let i = 0; i < this.item.allergies.length; i++) {
						let allergy = {
							index : i,
							name : this.item.allergies[i]
						};

						lstAllergies.push(allergy);
					}
					
					//
					//create product
					//
					let product = {
						itemId : this.item.itemId,
						itemName : this.item.itemName,
						categoryId : this.item.category,
						originalPrice : this.item.price,
						taxId : this.item.tax,
						description : this.item.description,
						estimatedTime : this.item.estimatedTime,
						allergiesJSON : JSON.stringify(this.item.allergies),
						groupOptionsJSON : JSON.stringify(this.item.groupOptions),
						shortName : this.item.shortName

					};
					await this.$store.dispatch('products/updateProductAction', { 'item' : product, 'image' : this.imageForUpload });
					this.clearItem();
					this.isVisible = false;
				}
				else {

				}
			})

		},

        showModal(product) {
			//
			//Reset first
			//
			this.clearItem();
			
			this.item.itemId = product.itemId;
			this.item.itemName = product.itemName;
			this.item.description = product.description;
			this.item.category = product.categoryId;
			this.item.tax = product.taxId;
			this.item.price = product.originalPrice;
			this.item.estimatedTime = product.estimatedTime;
			this.item.imageUrl = product.imageUrl;
			this.item.shortName = product.shortName;
			if (product.groupOptionsJSON !== null) {
				
				this.item.groupOptions = JSON.parse(product.groupOptionsJSON);
				//console.log(this.item.groupOptions)
			}

			if(product.allergiesJSON !== null) {
				this.item.allergies = JSON.parse(product.allergiesJSON);
			}
            this.isVisible = true;
			//this.$refs['imageUploader'].reset(); 
        },

		handleReadyUpload(file) {
            this.imageForUpload = file;
        },

		handleRemoveFile() {
			console.log('handleRemoveFile')
			this.imageForUpload = null;
		},

		clearItem() {
			this.item.itemId = '';
			this.item.itemName = '';
			this.item.description = '';
			this.item.category = null;
			this.item.tax = null;
			this.item.price = 0.0;
			this.item.estimatedTime = 0;
			this.item.imageUrl = '';
			this.item.addons = [];
			this.item.groupOptions = [];
			this.item.allergies = [];
			this.item.shortName = '';
		}
    },

	created()  {
		this.allergies = Allergies.AllergyIconSource;
		//this.resetAllergies();
	},
	destroyed() {
	
	}
}
</script>

<style lang="scss">
	.full-modal {
  		.ant-modal {
    		max-width: 100%;
    		top: 0;
    		padding-bottom: 50;
    		margin: 0;
  		}
  		.ant-modal-content {
    		display: flex;
    		flex-direction: column;
    		height: calc(100vh);
  		}
  		.ant-modal-body {
    		flex: 1;
  		}
	}
</style>